export default {
  all: [],
  options: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  query: {
    page: 1,
    limit: 50,
    search: '',
    isSet: false,
  },
  clientContacts: [],
  clientAddresses: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/client/state.js